import { configureApp } from '@infuse/ui/configure';

import { createIcon } from '@infuse/ui/plugins';
import { i18n } from '@infuse/utils';
import '@vuepic/vue-datepicker/dist/main.css';

import App from './App.vue';
import '@infuse/ui/styles/global.base.css';
import './global.css';

import { en, nl } from '@infuse/locale';

import { DashboardFeaturePlugin } from '@infuse/e-connector/dashboard/plugin';
import { ChargingStationFeaturePlugin } from '@infuse/e-connector/charging-station/plugin';
import { CentralSystemFeaturePlugin } from '@infuse/e-connector/central-system/plugin';
import { NetworkProfileFeaturePlugin } from '@infuse/e-connector/network-profile/plugin';
import { UserFeaturePlugin } from '@infuse/e-connector/user/plugin';
import { MessageFeaturePlugin } from '@infuse/e-connector/message/plugin';
import { ConnectorConfigPlugin } from '@infuse/e-connector/config/plugin';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { vPermission } from '@infuse/iam/permission/directives';
import { Feature } from '@infuse/cpms/shared/features/store';
import { UserFeaturePlugin as IamUserFeaturePlugin } from '@infuse/iam/user/plugin';
import { RoleFeaturePlugin } from '@infuse/iam/role/plugin';
import { TenantFeaturePlugin } from '@infuse/iam/tenant/plugin';
import { OrganisationFeaturePlugin } from '@infuse/iam/organisation/plugin';
import { baseUrlPrefix } from '@infuse/api/common';

i18n.global.mergeLocaleMessage('en', en);
i18n.global.mergeLocaleMessage('nl', nl);

const { VITE_APP_CONTEXT_PATH = null } = (import.meta as unknown as { env: Record<string, string> }).env;

configureApp(
  {
    configUrl: baseUrlPrefix(VITE_APP_CONTEXT_PATH) + '/api/meta/security-info/v2',
    mainRoute: '/dashboard',
    enableFeatureDiscovery: true
  },
  App,
  (app, features) => {
    app.use(DashboardFeaturePlugin);
    app.use(MessageFeaturePlugin);

    app.use(ChargingStationFeaturePlugin);
    app.use(CentralSystemFeaturePlugin);
    app.use(NetworkProfileFeaturePlugin);
    app.use(UserFeaturePlugin);

    app.use(ConnectorConfigPlugin);

    if (features && features.includes(Feature.IAM)) {
      app.use(IamUserFeaturePlugin);
      app.use(RoleFeaturePlugin);
      app.use(TenantFeaturePlugin);
      app.use(OrganisationFeaturePlugin);
    }

    app.use(createIcon());

    app.use(i18n);
    app.use(VueQueryPlugin);

    app.directive('permission', vPermission);
  }
);
